(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory((function webpackLoadOptionalExternalModule() { try { return require("@jupyter-widgets/base"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["@jupyter-widgets/base"], factory);
	else if(typeof exports === 'object')
		exports["escher"] = factory((function webpackLoadOptionalExternalModule() { try { return require("@jupyter-widgets/base"); } catch(e) {} }()));
	else
		root["escher"] = factory(root["@jupyter-widgets/base"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__51__) => {
return 